import {createClient} from '@sanity/client'
const sanityClient = createClient({
  // projectId: '7kn8usrb',
  projectId: 'vs95itr3',
  dataset: 'production',
  token: process.env.AIESEC_SANITY_TOKEN,
})

export default sanityClient